/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryWithRelations } from '../../models/inventory-with-relations';

export interface GetInventoryWithRelations$Params {
  identifiedBy: string;
  identifier: string;
  includeRemoved?: boolean;
}

export function getInventoryWithRelations(http: HttpClient, rootUrl: string, params: GetInventoryWithRelations$Params, context?: HttpContext): Observable<StrictHttpResponse<InventoryWithRelations>> {
  const rb = new RequestBuilder(rootUrl, getInventoryWithRelations.PATH, 'get');
  if (params) {
    rb.query('identifiedBy', params.identifiedBy, {});
    rb.query('identifier', params.identifier, {});
    rb.query('includeRemoved', params.includeRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InventoryWithRelations>;
    })
  );
}

getInventoryWithRelations.PATH = '/inventories/complete';
